module.exports = __webpack_public_path__ + "img/81.f99aa053.jpg";